import { Stepper, Division } from "@ir/ui";
import useAddChargebreakdown from "./hooks/useAddChargebreakdown";

const AddChargebreakdownSteps = () => {
  const { addChargebreakdownSteps, selectedSteps } = useAddChargebreakdown();

  return (
    <Division className="pt-1 flex-1">
      <Stepper steps={addChargebreakdownSteps} selectedKeys={selectedSteps} size="large" className="custom-stepper" aria-label="Stepper" aria-readonly={true} />
    </Division>
  );
};

export default AddChargebreakdownSteps;
